<template>
  <div class="area-models-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>S₁:S₂ = L₁:L₂ | 蝴蝶模型 | 燕尾模型$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="280" viewBox="0 0 500 280">
          <g transform="translate(100, 40)">
             <!-- Butterfly Model (Trapezoid) -->
             <g v-if="mode === 'butterfly'">
                <path d="M 0 0 L 300 0 L 250 200 L 50 200 Z" fill="rgba(255,255,255,0.02)" stroke="#888" stroke-width="2" />
                <!-- Diagonals -->
                <line x1="0" y1="0" x2="250" y2="200" stroke="#00d2ff" stroke-width="1.5" />
                <line x1="300" y1="0" x2="50" y2="200" stroke="#00d2ff" stroke-width="1.5" />
                
                <!-- Shaded Butterfly Wings (Left/Right equal area) -->
                <path d="M 125 100 L 0 0 L 50 200 Z" fill="rgba(0, 210, 255, 0.2)" />
                <path d="M 125 100 L 300 0 L 250 200 Z" fill="rgba(0, 210, 255, 0.2)" />
                
                <text x="60" y="110" fill="#fff" font-size="14">S左</text>
                <text x="180" y="110" fill="#fff" font-size="14">S右</text>
                <text x="120" y="40" fill="#aaa" font-size="12">S上</text>
                <text x="120" y="170" fill="#aaa" font-size="12">S下</text>
             </g>

             <!-- Swallowtail Model -->
             <g v-else-if="mode === 'swallowtail'">
                <path d="M 150 0 L 0 200 L 300 200 Z" fill="none" stroke="#2ed573" stroke-width="2" />
                <line x1="150" y1="0" x2="150" y2="200" stroke="#ff4757" stroke-dasharray="4" />
                <line x1="0" y1="200" x2="200" y2="80" stroke="#2ed573" />
                <line x1="300" y1="200" x2="100" y2="80" stroke="#2ed573" />
                
                <path d="M 150 200 L 0 200 L 100 80 Z" fill="rgba(255, 71, 87, 0.2)" />
                <path d="M 150 200 L 300 200 L 200 80 Z" fill="rgba(255, 71, 87, 0.2)" />
                <text x="50" y="180" fill="#fff">S₁</text>
                <text x="240" y="180" fill="#fff">S₂</text>
             </g>
          </g>
        </svg>

        <div class="hud-top">
          <div class="stat">
             <label>模型: {{ modeTitle }} (面积比例关系)</label>
          </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center gap-4">
            <div class="flex-1">
              <label>选择几何模型</label>
              <el-radio-group v-model="mode" size="mini">
                <el-radio-button label="butterfly">蝴蝶模型</el-radio-button>
                <el-radio-button label="swallowtail">燕尾模型</el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>核心结论：</strong><br>
          <span v-if="mode === 'butterfly'">在梯形中，对角线分成的四个三角形，左右两个面积相等；上、下两个面积之比等于其底边长度之比的平方。</span>
          <span v-else>燕尾模型通过底边公用的高度推导出各部分面积之比等于底边线段之比。</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeometricAreaModelsViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      mode: 'butterfly'
    }
  },
  computed: {
    modeTitle() { return this.mode === 'butterfly' ? '蝴蝶模型' : '燕尾模型'; }
  },
  mounted() {
    if (/燕尾/.test(this.knowledgePoint)) this.mode = 'swallowtail';
    else this.mode = 'butterfly';
  }
}
</script>

<style scoped lang="scss">
.area-models-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #010205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; overflow-y: auto; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
.row { display: flex; gap: 20px; align-items: center; }
label { font-size: 0.75rem; color: #888; margin-bottom: 5px; display: block; }
.flex-1 { flex: 1; }
</style>
